import React, { useState, useEffect, useRef } from "react";
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaCalendarAlt } from "react-icons/fa";
import axios from "axios";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Config } from "../../Config";
import Map from "../../components/Map/Map";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import Preloader from "../../components/Preloader/Preloader";
import Skeleton from "react-loading-skeleton";
import ReCAPTCHA from "react-google-recaptcha";
import Spinner from "../../components/Spinner/Spinner";
import "./ContactUs.scss";
import "./Responsive.scss";
import InputTooltip from "../../components/InputTooltip/InputTooltip";

const ContactUs = (props) => {
  const phoneRef = useRef(null);
  const contentRef = useRef(null);
  const subjectRef = useRef(null);
  const fullNameRef = useRef(null);
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [preloader, setPreloader] = useState(false);
  const [contact, setContact] = useState({});
  const [recaptcha, setRecaptcha] = useState("");
  const [showSpinner, setShowSpinner] = useState(false);
  const user = useSelector((state) => state.user);

  const breadCrumbData = [
    { title: "خانه", link: "/" },
    { title: "تماس با ما", link: "/contactus" },
  ];

  useEffect(async () => {
    Config.pageUp();
    await getContactData();
    if (user[0]?.token) {
      setPhone(user[0]?.mobile ?? "");
      setFullName(user[0]?.name ?? "");
    }
  }, []);

  const getContactData = () => {
    setPreloader(true);
    axios
      .get(
        "/Contact/GetContact",
        user[0]?.token && {
          headers: {
            Authorization: `Bearer ${user[0]?.token}`,
          },
        }
      )
      .then((result) => {
        setPreloader(false);
        setContact(result?.data?.data);
      })
      .catch((error) => {
        // console.log("error", error);
        setPreloader(false);
      });
  };

  const recaptchHandler = (recaptchaValue) => {
    setRecaptcha(recaptchaValue);
  };

  const fullNameHandler = (e) => {
    setFullName(e.target.value);
  };

  const emailHandler = (e) => {
    setEmail(e.target.value);
  };

  const phoneHandler = (e) => {
    setPhone(e.target.value);
  };

  const subjectHandler = (e) => {
    setSubject(e.target.value);
  };

  const messageHandler = (e) => {
    setMessage(e.target.value);
  };

  const submitContactForm = () => {
    if (recaptcha !== "") {
      setShowSpinner(true);
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      user[0]?.token && myHeaders.append("Authorization", `Bearer ${user[0]?.token}`);
      let raw = JSON.stringify({
        Name: fullName,
        Email: email,
        Phone: phone,
        Title: subject,
        Message: message,
        grec: recaptcha,
      });

      let requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(Config.apiPath + "/Contact/SendMessage", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === 200) {
            toast.success(<div>{result.messages}</div>);
            setShowSpinner(false);
            setFullName("");
            setEmail("");
            setPhone("");
            setSubject("");
            setMessage("");
            setRecaptcha("");
          } else {
            toast.error(<div>{result.messages}</div>);
            setShowSpinner(false);
          }
        })
        .catch((error) => {
          toast.error(error);
          setShowSpinner(false);
        });
    } else {
      toast.error("گزینه من ربات نیستم فعال نیست!");
    }
  };

  const expireRecaptcha = () => {
    setRecaptcha("");
  };

  const inputValidator = (action, input, tooltipId) => {
    let tooltip = document.getElementById(tooltipId);
    let isValid = 0;
    let message = "";
    if (action.regex) {
      let regex = action.regex.regex;
      if (regex.test(input.target.value)) {
        isValid -= 1;
      } else {
        message = action.regex.error;
        isValid += 1;
      }
    }
    if (action.required) {
      if (input.target.value !== "") {
        isValid -= 1;
      } else {
        isValid += 1;
        message = action.required;
      }
    }
    if (isValid >= 0) {
      tooltip.style.display = "flex";
      tooltip.innerText = message;
      input.target.style.border = "1px solid #f53b57";
      input.target.focus();
    } else {
      tooltip.style.display = "none";
      tooltip.innerText = "";
      input.target.style.border = "1px solid #b9b9b9";
    }
  };

  return (
    <section className="contactusWrapper mobile">
      <Helmet>
        {/* <title>ایران رگالو | تماس با ما</title> */}
        <title>{Config.helmetTitle} | تماس با ما</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      {/* {preloader && <Preloader active={preloader} />} */}
      <BreadCrumb breadCrumbData={breadCrumbData} />
      <div className="contactusContents">
        {contact.map ? (
          <Map map={contact && contact.map} />
        ) : (
          <Skeleton containerClassName="topMap" className="skeleton" highlightColor={Config.skeletonHighlightColor} />
        )}
        <div className="desktop">
          <div className="contactusInfo">
            <div className="contactusInfoTitle">
              <p className="title">اطلاعات تماس</p>
            </div>
            <div className="contactInfoContent">
              <div className="contactInfoAbout">
                <p className="title">{contact && contact.title}</p>
                <p className="infoItem">
                  <FaMapMarkerAlt /> {contact && contact.location}
                </p>
                <a href={`tel:${contact && contact.phone}`} className="infoItem">
                  <FaPhone /> {contact && contact.phone}
                </a>
                <a href={`mailto:${contact && contact.email}`} className="infoItem">
                  <FaEnvelope /> {contact && contact.email}
                </a>
              </div>
              <div className="contactInfoAbout">
                <p className="title">ساعت کاری</p>
                <p className="infoItem">
                  <FaCalendarAlt /> شنبه تا چهارشنبه &nbsp;
                  <span>
                    صبح {contact && contact.sa_WeStartClock} تا {contact && contact.sa_WeEndClock} عصر
                  </span>
                </p>
                <p className="infoItem">
                  <FaCalendarAlt /> پنج شنبه &nbsp;
                  <span>
                    صبح {contact && contact.thStartClock} تا {contact && contact.thEndClock} عصر
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="contactusInfo">
            <div className="contactusInfoTitle">
              <p className="title">
                سوالی دارید؟ <span>با استفاده از فرم زیر می توانید با ما ارتباط برقرار کنید</span>
              </p>
            </div>
            <div className="contactusForm">
              <div className="formBox">
                <div className="formGroup sm">
                  <div className="caption">
                    <input
                      type="text"
                      value={fullName}
                      onChange={(e) => fullNameHandler(e)}
                      id="name"
                      placeholder=""
                      ref={fullNameRef}
                      onBlur={(input) =>
                        inputValidator(
                          {
                            required: "* نام و نام خانوادگی نمی تواند خالی باشد!",
                            regex: {
                              regex: /^[،, \u0600-\u06FF\A-za-zs]+$/,
                              error: "* نام و نام خانوادگی معتبر نمی باشد!",
                            },
                          },
                          input,
                          "tooltipFullName"
                        )
                      }
                    />
                    <span className="placeholder">نام و نام خانوادگی *</span>
                    <InputTooltip display="none" id="tooltipFullName" />
                  </div>
                </div>
                <div className="formGroup sm">
                  <div className="caption">
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => emailHandler(e)}
                      id="email"
                      placeholder=""
                      ref={fullNameRef}
                      onBlur={(input) =>
                        inputValidator(
                          {
                            required: "* ایمیل نمی تواند خالی باشد!",
                            regex: {
                              regex:
                                /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
                              error: "* ایمیل معتبر نمی باشد!",
                            },
                          },
                          input,
                          "tooltipEmail"
                        )
                      }
                    />
                    <span className="placeholder">ایمیل *</span>
                    <InputTooltip display="none" id="tooltipEmail" />
                  </div>
                </div>
                <div className="formGroup sm">
                  <div className="caption">
                    <input
                      type="text"
                      value={phone}
                      onChange={(e) => phoneHandler(e)}
                      id="mobile"
                      placeholder=""
                      ref={phoneRef}
                      onBlur={(input) =>
                        inputValidator(
                          {
                            required: "* شماره تماس نمی تواند خالی باشد!",
                            regex: {
                              regex: /^(\+989|9|09)(12|19|35|36|37|38|39|32|30|28|22|21|20|00)\d{7}$/,
                              error: "* شماره تماس معتبر نمی باشد!",
                            },
                          },
                          input,
                          "tooltipMobile"
                        )
                      }
                      pattern="[0-9\u06F0-\u06F9]{10}"
                      maxLength="11"
                    />
                    <span className="placeholder">شماره تماس *</span>
                    <InputTooltip display="none" id="tooltipMobile" />
                  </div>
                </div>
                <div className="formGroup sm">
                  <div className="caption">
                    <input
                      type="text"
                      value={subject}
                      onChange={(e) => subjectHandler(e)}
                      id="subject"
                      placeholder=""
                      ref={subjectRef}
                      onBlur={(input) =>
                        inputValidator(
                          {
                            required: "* عنوان پیام نمی تواند خالی باشد!",
                            regex: {
                              regex: /^[،, \u0600-\u06FF\A-za-z0-9s]+$/,
                              error: "* عنوان پیام معتبر نمی باشد!",
                            },
                          },
                          input,
                          "tooltipSubject"
                        )
                      }
                    />
                    <span className="placeholder">موضوع *</span>
                    <InputTooltip display="none" id="tooltipSubject" />
                  </div>
                </div>
                <div className="formGroup">
                  <div className="caption">
                    <textarea
                      name=""
                      id="message"
                      value={message}
                      onChange={(e) => messageHandler(e)}
                      placeholder=""
                      maxLength="255"
                      ref={contentRef}
                      onBlur={(input) =>
                        inputValidator(
                          {
                            required: "* متن پیام نمی تواند خالی باشد!",
                            regex: {
                              regex: /^[،, \u0600-\u06FF\A-za-z0-9s]+$/,
                              error: "* متن پیام معتبر نمی باشد!",
                            },
                          },
                          input,
                          "tooltiContent"
                        )
                      }
                    ></textarea>
                    <span className="placeholder">متن پیام *</span>
                    <InputTooltip display="none" id="tooltiContent" />
                  </div>
                </div>
                <div className="formGroup">
                  <ReCAPTCHA
                    sitekey="6LfO7RAlAAAAAMcpWRyrmUNJYqmrl64Dp-h9u4Qt"
                    value={recaptcha}
                    onChange={recaptchHandler}
                    onExpired={expireRecaptcha}
                  />
                  {/* <ReCAPTCHA sitekey="6Lfgov0bAAAAAFGd8c6ALNbuFDyrElRKdUukingY" value={recaptcha} onChange={recaptchHandler} onExpired={expireRecaptcha} /> */}
                </div>
                <div className="formGroup">
                  <button type="submit" className="btnSend" onClick={submitContactForm}>
                    {showSpinner ? <Spinner color="#fff" /> : "ارسال"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default React.memo(ContactUs);
